import type { ReactNode } from 'react'
import React from 'react'
import { useLocation } from 'react-router-dom'

import { SuspenseFallback } from '@fourthwall/components'
import { isDevelopment } from '@fourthwall/utils/dist/dev'

import { useCurrentShop } from '../../../Dashboard/hooks/useCurrentShop'

type Props = {
  children: ReactNode
}

export const IncorrectDomainGuard = ({ children }: Props) => {
  const { pathname } = useLocation()
  const { currentShopQuery } = useCurrentShop()

  if (!currentShopQuery.isSuccess) {
    return <SuspenseFallback />
  }

  if (!isDevelopment() && currentShopQuery.data.internalBaseUri !== window.location.origin) {
    window.location.assign(`${currentShopQuery.data.internalBaseUri}${pathname}`)

    return null
  }

  return children
}
